module.exports = __webpack_public_path__ + "img/07.mostly-cloud-light.d5ebaa46.svg";